// i18n area 'cluster' — locale da-DK (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.da-DK.meta.json.
import type { enUS } from './cluster'

export const daDK: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Garantiadgange',
      subtitle: 'Nodens servicedør: den skrivebeskyttede adgang med midlertidig adgangskode og nødkontoen med adgangskoden fra boksen',
      readOnlyTitle: 'Skrivebeskyttet adgang (trantor)',
      stateNone: 'lukket',
      stateGranted: 'åben',
      stateGrantedPending: 'tildelt — anvendes på noden',
      grantedBy: 'Tildelt af',
      grantedAt: 'Tildelt den',
      expiresAt: 'Udløber den',
      reason: 'Årsag',
      endedAt: 'Lukket',
      endedReason: {
        revoked: 'tilbagekaldt',
        expired: 'udløbet (TTL)',
        reboot: 'genstart af noden',
        failed: 'ikke anvendt (opgave mislykkedes)'
      },
      grant: 'Tildel skrivebeskyttet adgang…',
      grantTitle: 'Tildel skrivebeskyttet adgang',
      grantSubmit: 'Tildel',
      grantError: 'Tildelingen blev afvist',
      grantConfirm: 'TVirt genererer en midlertidig adgangskode til systembrugeren «trantor» (kun læsning: journal og diagnostik, ingen sudo) og sætter den på noden med en opgave. Adgangskoden vises ÉN gang, ved bekræftelsen; den ophører ved udløb, ved tilbagekaldelse eller ved nodens næste genstart.',
      reasonLabel: 'Årsag',
      reasonHint: 'Hvorfor du åbner døren: det står i tildelingen, i audit og i journalen',
      ttlLabel: 'Varighed',
      ttlHours: '{n} t',
      revoke: 'Tilbagekald skrivebeskyttet adgang…',
      revokeTitle: 'Tilbagekald skrivebeskyttet adgang',
      revokeSubmit: 'Tilbagekald',
      revokeError: 'Tilbagekaldelsen blev afvist',
      revokeConfirm: 'Tildelingen ophører nu, og en opgave låser brugeren «trantor» på noden igen: den midlertidige adgangskode holder op med at virke.',
      passwordTitle: 'Skrivebeskyttet adgangskode',
      passwordOnce: 'Denne adgangskode vises ÉN gang: kopiér den nu. Den gemmes ingen steder og kan ikke læses igen — mister du den, så tildel igen.',
      passwordUser: 'Bruger',
      passwordLabel: 'Adgangskode',
      passwordHint: 'Gyldig indtil {until} eller indtil nodens næste genstart; kan bruges, når tildelingsopgaven er fuldført. Adgang: ssh trantor@<nodens adresse>.',
      emergencyTitle: 'Seneste nødadgang (trantor-emergency)',
      lastLogin: '{time} via {via} fra {from}',
      lastLoginNone: 'ingen observeret',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'konsol',
        sudo: 'sudo',
        unknown: 'ukendt'
      },
      emergencyHint: 'Nødkontoen «trantor-emergency» (fuld sudo) er altid aktiveret med adgangskoden, der blev genereret ved nodens installation og opbevares i boksen: TVirt kender den ikke, roterer den ikke og gendanner den ikke. Hvert login rapporteres her og i hændelsesjournalen.'
    },
    nodeFirewall: {
      tab: 'Firewall',
      title: 'Nodernes firewall',
      subtitle: 'Holdningen for det nftables-ruleset, hver node anvender på sig selv — en nodes eneste firewall (firewalld er deaktiveret)',
      modeLabel: 'Holdning',
      mode: {
        disabled: 'Deaktiveret — intet ruleset på noderne',
        permissive: 'Permissiv — tæller og logger, dropper intet',
        enforced: 'Håndhævet — kun det afledte register kommer ind'
      },
      hint: {
        disabled: 'Som i dag: noderne bærer intet ruleset. Skift til permissiv for at LÆSE, hvad der ville blive droppet, før det bliver droppet.',
        permissive: 'Hver node anvender sit eget afledte ruleset med policy accept: det, som håndhævet tilstand ville droppe, tælles og logges (journal-præfiks «tvirt-node would-drop:»). Intet blokeres.',
        enforced: 'Hver node anvender sit eget afledte ruleset med policy drop: ssh og API fra alle steder, store / live migration / overlay / Ceph kun fra medlemmerne, netværkstjenesternes listeners fra det betjente netværk. Hvert skift er et apply med bekræftelse — en node, der ikke kan bekræfte, ruller selv tilbage.'
      },
      confirmTitle: 'Håndhæv nodernes firewall?',
      confirmBody: 'Hver node anvender rulesettet med bekræftelse: den tester backend, store og ssh gennem de nye regler inden fristen og bekræfter — ellers ruller den selv tilbage til det forrige ruleset. Læs først tællerne fra permissiv tilstand på noderne.',
      confirmSubmit: 'Håndhæv',
      confirmCancel: 'Annuller',
      lensTitle: 'Nodens firewall',
      loadError: 'Kunne ikke indlæse nodens firewall-linse',
      noReport: 'Ingen firewall-rapport fra denne node endnu — workeren rapporterer ved sit næste pass',
      firewalldActive: 'På denne node kører firewalld: node-firewallen nægter at anvende sig ved siden af den (masker firewalld)',
      conditionUnconfirmed: 'Intet bekræftet ruleset endnu — noden er åben',
      conditionRolledBack: 'Seneste apply rullede tilbage — samme generation forsøges ikke igen, før registret ændrer sig, eller holdningen skiftes igen',
      lastError: 'Seneste fejl',
      posture: 'Holdning',
      observedAt: 'Observeret',
      desiredGeneration: 'Ønsket generation',
      componentTitle: 'Nodekomponent',
      componentSubtitle: 'tvirt-node-firewall — anvender det bekræftede ruleset ved boot, ruller selv et ubekræftet tilbage',
      componentAbsent: 'Komponenten har endnu ikke rapporteret',
      phase: 'Fase',
      phases: {
        none: 'Aldrig anvendt',
        applied: 'Anvendt — afventer bekræftelse',
        confirmed: 'Bekræftet',
        rolledBack: 'Rullet tilbage'
      },
      generation: 'Generation',
      appliedAt: 'Anvendt den',
      confirmedAt: 'Bekræftet den',
      deadline: 'Rollback-frist',
      lastRollback: 'Seneste rollback',
      registryTitle: 'Afledt register',
      registrySubtitle: 'De porte, denne node åbner, efter klasse og oprindelse — afledt af clusteret, aldrig redigeret i hånden',
      registryEmpty: 'Intet afledt — holdning deaktiveret uden bekræftet ruleset, eller ingen rapport endnu',
      colClass: 'Klasse',
      colPort: 'Port',
      colSource: 'Kilde',
      colOrigin: 'Oprindelse',
      classes: {
        public: 'Offentlig',
        internode: 'Inter-node',
        tenant: 'Tenant'
      },
      sourceMembers: 'kun medlemmerne',
      sourceAnywhere: 'alle steder',
      sourceBridge: 'på {iface}'
    },
    derivationDerived: 'afledt',
    derivationDiverged: 'afveget',
    derivationDerivedTip: 'Netværksdokumentet er AFLEDT af fabric {fabric} og matcher stadig renderet på de aktuelle input — klik for derivationsplanen.',
    derivationDivergedTip: 'Derivationen fra fabric {fabric} ændrede sig efter sidste apply (fabric, kabling, roller eller referencer) — klik for den udestående diff.',
    derivationRetiring: {
      one: '{n} adresse dræner',
      other: '{n} adresser dræner'
    },
    standaloneHint: 'Denne node har intet cluster: den er endnu ikke installeret. Clustre oprettes ELLER joines ved installationen — tokenet genereret fra et medlems Server-tabel gives til installeren (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Dine tilladelser dækker et scope, ikke hele clusteret: flådeinventaret — noder, indstillinger og enheder — er kun synligt for cluster-administratorer.',
    phaseReady: 'Klar',
    phaseForming: 'Under dannelse',
    storeMembers: 'Storens medlemmer',
    watermark: 'Konvergenstærskel',
    configGeneration: 'Config-generation',
    converged: 'på linje',
    behind: 'bagud — {m} / {n}',
    revision: 'Revision',
    rolesTitle: 'Netværksroller',
    rolesSubtitle: 'Adresser pr. medlem for hver trafikklasse — konnektiviteten bor i host-netværket',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'arver management',
    settingsTitle: 'Indstillinger',
    settingsSubtitle: 'Sikkerhedspolitik på cluster-niveau — evalueret af hver node fra dens egen lokale replika',
    taskRetentionTitle: 'Task-retention',
    taskRetentionSubtitle: 'Samlet GC for alle tasks — afsluttede tasks ud over alderen eller loftet indsamles, aldrig dem i gang',
    taskRetentionMaxAge: 'Maksimal alder (dage)',
    taskRetentionMaxCount: 'Maksimalt antal tasks',
    eventRetentionTitle: 'Hændelsesopbevaring',
    eventRetentionSubtitle: 'Journalens GC — en politik uafhængig af opgavernes: opgaven er en kø, hændelsen er hukommelse',
    eventRetentionMaxAge: 'Maksimal alder (dage)',
    eventRetentionMaxCount: 'Maksimalt lagrede hændelser',
    spaceThresholdsTitle: 'Pladstærskler',
    spaceThresholdsSubtitle: 'Når en lagring der fyldes når journalen (og notifikationerne)',
    spaceLowPct: 'Advarsel fra (% brugt)',
    spaceCriticalPct: 'Kritisk fra (% brugt)',
    spaceOrderError: 'Kritisk kan ikke ligge under advarslen',
    spaceThresholdsHint: 'Kun indgangene konfigureres: udgangen udledes af motoren, 5 point under hver tærskel, så en lagring på linjen aldrig bliver en metronom',
    failoverReserveTitle: 'Failover-reserve',
    failoverReserveSubtitle: 'N+1 admission control — RAM holdt fri, så clusteret kan genstarte sin egen last efter tab af noder',
    failoverReserveTolerate: 'Noder, hvis tab skal tolereres',
    failoverReserveOff: '0 — reserven er slukket: ingen start afvises nogensinde af hensyn til failover-kapacitet',
    failoverReserveOn: 'En start, der ville tære på reserven, afvises med en 412, der forklarer tallene',
    networkShapingTitle: 'Båndbreddefairness',
    networkShapingSubtitle: 'De tre typologivægte i shaping-træet pr. uplink — de virker kun under kappestrid',
    networkShapingRest: 'Vægt for resten (kontrolplan, storage, replikaer)',
    networkShapingOverlay: 'Vægt for overlay-netværk',
    networkShapingLiveMigration: 'Vægt for live migration',
    networkShapingHint: 'Garanteret andel = vægt / sum af de tre (standard 300 / 100 / 200, hver fra 1 til 10000); på et ledigt link kan hver klasse tage hele båndbredden',
    debugModeTitle: 'Debug-tilstand',
    debugModeSubtitle:
      'Detaljerede fejl i de generiske GUI-beskeder — for at se den virkelige årsag, når en handling, der »fejlede«, rent faktisk lykkedes',
    debugModeLabel: 'Debug-tilstand aktiveret',
    debugModeOn: 'Generiske fejlbeskeder tilføjer den underliggende årsag — interne detaljer synlige for enhver operatør',
    debugModeOffHint: 'Slukket — generiske fejlbeskeder forbliver generiske, uden interne detaljer',
    nodeDetailsAction: 'Nodedetaljer',
    node: {
      docTitle: 'Node',
      notFound: 'Node ikke fundet',
      tabOverview: 'Oversigt',
      tabStats: 'Statistik',
      tabNetwork: 'Netværk',
      tabSettings: 'Lokale indstillinger',
      identityTitle: 'Identitet',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'YSQL-port',
      revision: 'Config-revision',
      versionsTitle: 'Observerede versioner',
      heartbeatSubtitle: 'Den seneste tilstand, noden har rapporteret om sig selv',
      cpuTitle: 'CPU',
      cpuModelTitle: 'CPU-model',
      memoryTitle: 'Hukommelse',
      hugePagesTitle: 'Enorme sider',
      hugePagesPool: '{size}: {free} ledige af {total}',
      hugePagesNone: 'Ingen pulje',
      hugePagesNoneHint: 'Noden har ingen enorme sider reserveret: virtuelle maskiner, der beder om dem, kan ikke starte her. Puljen erklæres på noden med kerneparametrene hugepagesz og hugepages eller ved at skrive nr_hugepages.',
      usageTitle: 'Aktuelt forbrug',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'ikke observeret — ingen frisk stikprøve',
      statsNoData: 'Ingen data i intervallet — nodens serier samples af noden selv og serveres lokalt.',
      observedTitle: 'Observeret tilstand',
      observedSubtitle: 'Tjenester og assets lokale for noden, som workeren ser dem'
    },
    editRolesTitle: 'Rediger netværksrollerne',
    memberNode: 'Node',
    memberIp: 'IP-adresse',
    addMember: 'Tilføj medlem',
    lmInherit: 'Brug management-adresserne',
    roleIpHint: 'At tilføje og fjerne medlemmer er frit; at ændre et eksisterende medlems IP på stedet afvises — IP-migreringsflowet kommer i et senere round.',
    roleError: 'Kunne ikke opdatere rollerne',
    nodesTitle: 'Noder',
    addNodeTitle: 'Tilføj node til clusteret',
    addNode: 'Tilføj node',
    addNodeError: 'Kunne ikke forhåndsregistrere noden',
    nodeName: 'Nodens navn',
    nodeNameHint: 'skal matche navnet valgt ved installationen',
    nodeIp: 'Management-IP',
    colName: 'Navn',
    colPhase: 'Fase',
    colServices: 'Tjenester',
    colWatermark: 'Watermark',
    colLastSeen: 'Seneste kontakt',
    colUps: 'UPS',
    upsCordonChip: 'UPS-afspærring',
    upsCordonTip: 'Noden dømte sig selv på sin UPS’ fakta ({time}): den ophæver selv afspærringen, når nettet er stabilt og batteriet genopladet',
    upsUnreachable: 'UPS utilgængelig',
    upsOnBattery: 'På batteri',
    upsOnLine: 'På net',
    upsLowBattery: 'lavt batteri',
    upsNoEstimateChip: 'restløbetid ikke estimeret',
    upsNoEstimateTip: 'UPS’en offentliggør intet estimat af restløbetiden: noden dømmes alene af UPS’ens LB-flag (lavt batteri) — juster battery.runtime.low / LB på selve UPS’en',
    upsLaneTip: 'UPS-nedlukningsbane siden {since}: dømt af {by}',
    upsUnit: 'enhed',
    upsStatus: 'NUT-status',
    upsLoad: 'belastning',
    upsOnBatterySince: 'på batteri siden',
    upsOnLineSince: 'på net siden',
    upsError: 'fejl',
    upsObservedAt: 'observeret',
    upsNone: 'ingen UPS-enhed betjener denne node',
    upsBy: {
      runtime: 'restløbetid under tærsklen',
      lowBattery: 'UPS’ens LB-flag',
    },
    upsLane: {
      evacuate: 'evakuering',
      local: 'nedlukning på stedet',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'stopper gæster',
      stoppingServices: 'stopper tjenester',
      poweredOff: 'slukket',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'UPS-enheder og tærskler: noden dømmes ved restløbetid ≤ tærskel eller LB-flag (altid respekteret), genoptagelse med hysterese',
    upsRuntimeThreshold: 'Tærskel for restløbetid (s)',
    upsRuntimeThresholdHint: 'På batteri med estimeret restløbetid ≤ tærskel lukker noden ned i rækkefølge (standard 300)',
    upsResumeStable: 'Net stabilt i (s)',
    upsResumeStableHint: 'Genoptag kun med uafbrudt net i mindst så mange sekunder (standard 60)',
    upsResumeCharge: 'Minimumsladning ved genoptagelse (%)',
    upsResumeChargeHint: 'Og batteri genopladet til mindst denne procentdel (standard 25)',
    upsPolicyNote: 'UPS’ens LB-flag (lavt batteri) dømmer altid og kan ikke slås fra; der findes ingen tærskel for tiden på batteri. Hver enhed kan overskrive de tre tal.',
    upsUnitNew: 'ny enhed',
    upsUnitSelectors: '{n} tag-vælger(e) (kun CLI)',
    upsUnitName: 'Enhedens navn',
    upsUnitMode: 'Tilstand',
    upsModeExternal: 'ekstern (andres upsd)',
    upsModeManaged: 'administreret (UPS tilsluttet en node)',
    upsUnitUpsname: 'NUT-navn (upsname)',
    upsUnitHost: 'upsd-vært',
    upsUnitAttachedNode: 'Tilsluttet node',
    upsUnitDriver: 'NUT-driver',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Driverens enhed',
    upsUnitDeviceHint: 'linjen port= i ups.conf: tom = auto',
    upsUnitPort: 'upsd-port',
    upsUnitServedNodes: 'Betjente noder',
    upsUnitServedNodesHint: 'nodenavne adskilt af kommaer (tag-vælgere går via CLI)',
    upsUnitOverrideHint: 'tom = klyngens standard',
    upsUnitAdd: 'Tilføj enhed',
    unreachableSince: 'Kan ikke nås — seneste heartbeat {time}',
    overlaysChip: 'overlay',
    overlaysBehind: 'Overlay-dataplanet har endnu ikke realiseret den aktuelle overlay-konfiguration',
    overlaysError: 'Seneste overlay-afstemningspass fejlede: {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'Afventer join',
      'joining': 'Joiner',
      'member': 'Medlem'
    },
    tokenTitle: 'Join token',
    tokenOnce: 'Vises kun nu — kopier det straks, det kan ikke læses igen',
    copy: 'Kopier',
    copied: 'Kopieret',
    close: 'Luk',
    revokeTitle: 'Tilbagekald forhåndsregistrering',
    revoke: 'Tilbagekald',
    revokeError: 'Kunne ikke tilbagekalde registreringen',
    promote: 'Forfrem til store member',
    demote: 'Fjern store member-rollen',
    troubleshoot: 'Fejlfinding',
    promoteTitle: 'Forfrem til store member',
    demoteTitle: 'Fjern store member-rollen',
    promoteHint: 'Noden træder ind i YugabyteDB-masternes quorum. Ægte HA kræver tre store members.',
    demoteHint: 'Noden forlader masternes quorum og stopper sine store-tjenester.',
    storeError: 'Ændringen af store member blev afvist',
    attest: 'Attester slukket…',
    attestTitle: 'Attester noden slukket',
    attestSubmit: 'Attester slukket',
    attestConfirm: 'Du erklærer denne node slukket, på eget ansvar: at attestere en node, der i virkeligheden er i live, risikerer dobbeltkørende VM. Dens tasks fejles, og dens VM-authorities bliver overførbare.',
    attestError: 'Attesteringen blev afvist',
    attestedChip: 'attesteret slukket',
    maintenanceChip: 'vedligeholdelse',
    guestToolsChip: 'TVirt Guest Tools (ISO-asset lokal for noden)',
    maintenanceEnter: 'Aktiver vedligeholdelse',
    maintenanceExit: 'Deaktiver vedligeholdelse',
    maintenanceEnterTitle: 'Aktiver vedligeholdelse',
    maintenanceExitTitle: 'Deaktiver vedligeholdelse',
    maintenanceEnterSubmit: 'Aktiver vedligeholdelse',
    maintenanceExitSubmit: 'Deaktiver vedligeholdelse',
    maintenanceEnterConfirm: "Noden afspærres og tømmes: netværkstjenesterne og App-instanserne, hvis authority den holder, overføres (instanserne koldt: stoppet og høstet her, genskabt på målnoden — nedetid), kørende VM'er live-migreres hvor muligt og stoppes ellers pænt, igangværende opgaver afsluttes, nyt arbejde holdes tilbage, og de stoppede VM'er mister deres authority — Proximity placerer dem igen ved næste start. Intet kommer tilbage af sig selv, når vedligeholdelsen slutter.",
    maintenanceExitConfirm: 'Noden genoptager arbejdet, og Proximity overvejer den igen til placement. VM vender kun tilbage, når de startes.',
    maintenanceError: 'Vedligeholdelsesanmodningen blev afvist',
    maintenancePlanTitle: 'Evakueringsplan',
    maintenancePlanLoading: 'Beregner evakueringsplanen…',
    maintenancePlanError: 'Kunne ikke indlæse evakueringsplanen — drain migrerer alligevel, hvor det er muligt, og stopper resten.',
    maintenancePlanEmpty: 'Intet at evakuere på denne node — ingen aktiv netværkstjeneste, ingen App-instans ønsket kørende, ingen kørende VM.',
    maintenancePlanSummary: "{migrate} objekter migrerer (VM'er, netværkstjenester, App-instanser), {stop} stoppes eller bliver, hvor de er.",
    maintenancePlanReserve_ok: 'Failover-reserve efter tømningen: intakt — der er {headroom} GiB tilbage at starte på med tolerance for tab af {n} node(r).',
    maintenancePlanReserve_eroded: 'Failover-reserve efter tømningen: næsten opbrugt — kun {headroom} GiB tilbage af de {reserve} GiB holdt fri til {n} nodefejl.',
    maintenancePlanReserve_exhausted: 'Failover-reserve efter tømningen: OPBRUGT — der mangler {headroom} GiB af de {reserve} GiB, der kræves for at tolerere {n} nodefejl. Så længe denne node er ude, afvises nye VM-starter.',
    maintenancePlanReserve_unknown: 'Failover-reserve efter tømningen: kan ikke beregnes — ingen tilbageværende node har erklæret sin hukommelse.',
    maintenancePlanReserveHugePages: 'Enorme sider på {size} efter tømningen — frie: {free} af {capacity}, krævet som reserve: {reserve}.',
    maintenancePlanActionMigrate: 'migrerer',
    maintenancePlanActionMigrateWarning: 'migrerer (soft-regel overtrådt)',
    maintenancePlanActionStop: 'stopper',
    maintenancePlanActionBlocked: 'blokeret',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'netværkstjeneste',
    maintenancePlanKindApp: 'App-instans',
    maintenancePlanColdMove: 'Kold flytning: podden stoppes og høstes her og genskabes på målnoden af dens worker — nedetid indtil målworkerens næste pass.',
    caFingerprint: "Fingerprint for clusterets CA",
    staleChip: 'ikke opdateret',
    troubleshootTitle: 'Fejlfinding af storen',
    restartStore: 'Genstart store-tjenesterne',
    restartHint: 'Hvis storen driller, så genstart dens tjenester. Avanceret — brug med forsigtighed.',
    restartQueued: 'Genstart-task sat i kø',
    restartError: 'Kunne ikke genstarte tjenesterne',
    svcActive: 'aktiv',
    svcWanted: 'ønsket, ikke aktiv',
    svcStopped: 'stoppet',
    noServices: 'Ingen tjenester rapporteret'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'Hele clusterets GPU-inventar grupperet efter model — kortene observeret pr. node, med de markerede registreringer og deres tags',
    usbTitle: 'USB-ressourcer',
    usbSubtitle: 'Hele clusterets USB-inventar grupperet efter model — enhederne observeret pr. node, med registreringerne efter begge modeller (pr. enhed, pr. port) og deres tags',
    markedChip: '{n} brugbare for TVirt',
    orphanChipGpu: '{n} forældreløse',
    orphanChipUsb: '{n} forældreløse',
    colNode: 'Node',
    colRegistration: 'Registrering',
    noRegsHint: 'Ingen registrering — enheden markeres "brugbar for TVirt" fra nodens dialog (Noder › node › Indstillinger).',
    colDevice: 'Enhed',
    colObserved: 'Observerede',
    colRegs: 'Registreringer',
    regsNone: 'ingen',
    colPci: 'PCIe-adresse',
    colIdentity: 'Identitet / port',
    colClasses: 'Klasser (tags)',
    colActions: 'Handlinger',
    manageOnNode: 'Håndter på noden {node} (markeringen bor i nodens dialog)',
    introTitle: 'Cluster-inventaret over USB- og PCIe-enheder brugbare for TVirt©.',
    introStep1: '1. Noderne opdager selv deres GPU- og USB-enheder (optælling i heartbeatet).',
    introStep2: '2. En enhed markeres "brugbar for TVirt" fra NODENS dialog (Noder › node › Indstillinger) — markeringen binder den til vfio og registrerer den her.',
    introStep3: '3. Her giver du registreringerne deres KLASSER via tags (fx gpu_class=compute): VM-kravene beder om en klasse, og scheduleren vælger en node med en ledig kompatibel enhed.',
    colMode: 'Model',
    colState: 'Status',
    colNotes: 'Noter',
    colTags: 'Tags',
    modeDevice: 'pr. enhed',
    modePort: 'pr. port',
    usable: 'brugbar',
    orphanGpu: 'forældreløs',
    orphanUsb: 'forældreløs',
    hubChip: 'hub',
    orphanPortsTitle: 'Registreringer pr. port uden tilsluttet enhed — tilslut en enhed igen, eller afmarker dem fra noden',
    gpusEmpty: 'Ingen GPU observeret endnu på nogen node',
    usbEmpty: 'Ingen USB-enhed observeret endnu på nogen node'
  },
  settings: {
    passwordMinLength: 'Minimumslængde for adgangskoder',
    sessionIdle: 'Timeout for inaktiv session (minutter)',
    lockoutThreshold: 'Låsning efter mislykkede forsøg',
    lockoutDuration: 'Låsningens varighed (minutter)',
    keyboardLayout: 'Tastaturlayout',
    keyboardLayoutHint: 'fx da, en-us — tomt for QEMU-defaulten',
    syslogEndpoint: 'Syslog-endpoint',
    syslogEndpointHint: 'host:port — tomt for at deaktivere videresendelsen',
    syslogTls: 'TLS',
    maxQueued: 'Maksimalt antal tasks i kø',
    concurrency: 'Workerens concurrency',
    concurrencyHint: 'Anvendes af workeren i farten',
    notesTitle: 'Noter',
    save: 'Gem',
    saved: 'Indstillinger gemt',
    saveError: 'Kunne ikke gemme indstillingerne'
  },
  localSettings: {
    derivedChip: 'afledt',
    derivedTip: 'Dette device EJES af fabric-derivationen (H2): editoren nægter at røre det — ret fabric\'en (eller kablingen) og anvend igen, eller tag det tilbage nedenfor.',
    takeOwnership: 'Overtag ejerskab',
    takeOwnershipTitle: 'Overtag ejerskab (take-ownership)',
    takeOwnershipConfirm: '{name} forlader fabric-blokken og bliver igen et MANUELT device, som denne editor styrer. Noden bliver afveget, og næste derivations-apply afviser på den (manualConflict), indtil du omdøber eller fjerner det — eller retter fabric\'en.',
    nodeSettingsTitle: 'Nodeindstillinger',
    nodeSettingsSubtitle: 'Det, denne node anvender — task-kø, konsol, log-videresendelse — plus dens tags og noter',
    baseTitle: 'Host-reserver (TVirt Proximity)',
    baseSubtitle: 'CPU og RAM reserveret til hostens operativsystem — inputtene til den empiriske kapacitet, som Proximity placerer VM med',
    baseMemory: 'Basis-RAM (MiB)',
    baseMemoryHint: 'Observeret total: {total} MiB. Brugbar for VM = total − basis − RAM for de tændte VM placeret her.',
    baseMemoryHintNoTotal: 'Brugbar for VM = observeret total − basis − RAM for de tændte VM placeret her.',
    baseCpu: 'Basis-CPU-kerner',
    baseCpuHint: 'Observerede logiske CPU: {total}. Bruges kun som ranking-vægt — vCPU-overcommit er normalt.',
    baseCpuHintNoTotal: 'Bruges kun som ranking-vægt — vCPU-overcommit er normalt.',
    baseHint: 'RAM er den hårde admission-gate: en VM, der ikke kan være i den brugbare RAM, afvises med en talende fejl. Hæv basen på hosts, der huser store-medlemmer eller Ceph-daemons.',
    placementTitle: 'Fysisk placering',
    placementSubtitle: 'Hvor denne server fysisk står — erklæret én gang, til hvad end der er brug for',
    placementHint: 'Placeringen styrer CRUSH-hierarkiet for hvert Ceph-cluster med en OSD på denne server: at gemme en ændring bringer deres maps på linje via task (host → rack → … → root). Delvise erklæringer er lovlige — tomme niveauer kollapser. Navnene deles over hele mappen: to servere i samme rack erklærer det samme rack-navn.',
    placementNameInvalid: 'DNS-safe navn (små bogstaver, cifre, bindestreger)',
    placementEmpty: 'Tomt = ikke erklæret',
    placementLevel: {
      chassis: 'Chassis',
      rack: 'Rack',
      row: 'Række',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Rum',
      datacenter: 'Datacenter',
      zone: 'Zone',
      region: 'Region'
    },
    cablingTitle: 'Kabling',
    cablingSubtitle: 'Hvilken switchport hvert interface er koblet til — erklæringen bor på noden (Annex O.9)',
    cablingHint: 'Ét kabel pr. NIC, ét kabel pr. port i hele flåden (API afviser og nævner indehaveren). At kable mod en port, der er medlem af en LAGG, er lovligt — det er bond-tilfældet: den fremtidige afledning renderer det som LACP.',
    cablingInterface: 'Interface',
    cablingNotCabled: '— ikke kablet —',
    cablingNoInterfaces: 'Intet netværksinterface observeret',
    disksTitle: 'Diske',
    disksSubtitle: 'Observerede blokenheder — én scanning pr. afstemningspass; marker her de diske, der kan bruges som Ceph-OSD (N.15: egnethed er eksplicit)',
    colDataDisk: 'Datadisk',
    dataDisksHint: 'At afkrydse en enhed erklærer den brugbar som OSD; serienummeret er dens identitets-pin — kopieret fra hardwaren, når disken rapporterer det, præget (tvirt-…) ellers. Ceph-registreringsdialogen tilbyder kun de erklærede diske.',
    diskDeclaredSerial: 'erklæret',
    diskNotObserved: 'erklæret, men ikke observeret — tilslut devicet igen, eller fjern krydset',
    noDisks: 'Ingen blokenheder observeret endnu',
    colSerial: 'Serienummer',
    colModel: 'Model',
    colSize: 'Størrelse (GiB)',
    colDiskType: 'Type',
    colInUse: 'I brug',
    colObservedAt: 'Observeret',
    diskInUse: 'i brug',
    diskFree: 'ledig',
    diskMounted: 'monteret',
    diskPartitions: 'partitioner',
    passthroughTitle: 'Passthrough-enheder',
    passthroughSubtitle: 'Observerede GPU- og USB-enheder — marker her, hvad TVirt må give videre til VM; markeringen registrerer enhedens identitet (round U1+G1)',
    passthroughHint: 'Markeringen registrerer enheden (et stabilt id — target for tags og klassekrav). En markeret GPU får HELE sin IOMMU-gruppe bundet til vfio-pci samlet — den forlader hosten med det samme; afmarkering tilslutter den native driver igen. For USB findes begge de ratificerede modeller: pr. enhed (vendor+produkt, uanset hvor den er sat i) og pr. fysisk port (VM får, hvad end der sidder i den). USB bindes ikke ved markeringen — attach sker ved VM-runtime.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Brugbar for TVirt',
    colGpu: 'GPU',
    colPciAddress: 'PCI-adresse',
    colDriver: 'Driver',
    colVerdict: 'Dom',
    gpuEligible: 'Egnet',
    gpuIneligible: 'Ikke egnet',
    gpuReason: {
      'no-iommu': 'IOMMU er ikke aktiv på hosten',
      'group-spans-slots': 'IOMMU-gruppen er ikke isoleret: den strækker sig over andre slots',
      'multiple-display': 'IOMMU-gruppen er ikke isoleret: mere end én videofunktion',
      'foreign-function': 'IOMMU-gruppen er ikke isoleret: den indeholder en fremmed funktion'
    },
    vfioNotReady: 'IOMMU er ikke aktiv på denne host: ingen GPU er egnet, før host-platformen aktiverer den (OEM-ISO) — TVirt piller aldrig ved kernel args ved runtime.',
    vfioMissingKernelArg: 'IOMMU er ikke aktiv på denne host: firmwaren rapporterer VT-d/AMD-Vi (ACPI-tabellen DMAR/IVRS er til stede), men kernel-arget mangler — tilføj intel_iommu=on (Intel), eller fjern amd_iommu=off (AMD) fra kernens command line og genstart. TVirt piller aldrig ved kernel args ved runtime.',
    vfioFirmwareDisabled: 'IOMMU er ikke aktiv på denne host: VT-d/AMD-Vi er deaktiveret i firmwaren (ingen ACPI-tabel DMAR/IVRS), eller også understøtter CPU\'en det ikke — aktiver det i firmware-setuppet, intet kernel arg kan tænde det. TVirt piller aldrig ved hosten ved runtime.',
    gpuBindError: 'vfio-pci-bind fejlede på {address}: {error}',

    // Firewall su bridge non gestiti (#168 §9-bis): la lista del consenso.
    firewallBridgesTitle: 'Firewall på ikke-håndterede bridges',
    firewallBridgesSubtitle: "De håndbyggede bridges på denne node, hvis setup giver samtykke til TVirt-renderede firewall-chains på de tilsluttede guest-NIC'er",
    firewallBridgesHint: 'TVirt rører aldrig den fremmede bridge — chainen forankres på tap/veth, som altid er TVirts egen. Listen er en samtykkeport: default-deny og anti-spoof kan ødelægge, hvad et manuelt setup forventer, så en NIC med firewall på en ikke-håndteret bridge, der IKKE står her, afvises med en talende fejl.',
    firewallBridgesEmpty: 'Ingen ikke-håndteret bridge giver samtykke til TVirt-renderede firewall-chains på denne node.',
    firewallBridgeAdd: 'Tilføj bridge',
    firewallBridgeInvalid: 'Ikke et Linux-interfacenavn (1-15 tegn, uden skråstreg eller mellemrum)',
    firewallBridgeDuplicate: 'Navnet står allerede på listen',
    colMarkDevice: 'Pr. enhed',
    colMarkPort: 'Pr. port',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Port',
    passthroughOrphan: 'forældreløs — registreret, men ikke længere detekteret: tilslut den igen, eller afmarker den',
    noGpus: 'Ingen GPU observeret endnu',
    noUsb: 'Ingen USB-enhed observeret endnu',
    networkGeneration: 'Netværksgeneration',
    applied: 'Anvendt',
    converged: 'på linje',
    behind: 'bagud — {m} / {n}',
    notConfigured: 'ikke konfigureret',
    rollbackBody: 'Anvendelsen af generation {gen} fejlede: {error}',
    rolledBackChip: 'rollback udført',
    nicsTitle: 'NIC',
    nicsSubtitle: 'Registret over håndterede NIC-enheder — registreringen ER erklæringen om håndtering: en registreret NIC uden konfiguration røres ikke (clear-if erklærer den eksplicit ren), en uregistreret enhed røres aldrig',
    addNic: 'Registrer NIC',
    addNicTitle: 'Registrer NIC (add-nic)',
    delNic: 'Afslut håndtering',
    delNicTitle: 'Afslut håndtering (del-nic)',
    delNicConfirm: 'Håndteringen af {name} slutter: registerposten og dens konfiguration slettes, og TVirt-profilen fjernes — enheden forbliver, som Linux har den.',
    nicName: 'Enhedens navn',
    nicMac: 'Permanent MAC-adresse',
    nicMacHint: 'den permanente hardware-MAC — den stabile identitet fastlagt af TVirt Server Installer',
    colObserved: 'Observeret',
    nicObserved: 'observeret',
    nicNotObserved: 'ikke observeret',
    nicMacMismatch: 'Divergerende MAC — observeret {mac}',
    noNics: 'Ingen NIC registreret — registrer en enhed for at begynde at håndtere den',
    noManagedDevices: 'Ingen håndterede enheder — registrer først en NIC, alt bygger på registret',
    inventoryTitle: 'Observerede enheder',
    inventorySubtitle: 'Opdateret ved hvert afstemningspass af nodens worker — valideringen tjekker enhedsnavnene mod dette inventar',
    colDevice: 'Enhed',
    colType: 'Type',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Hastighed',
    colTopology: 'Topologi',
    colMtu: 'MTU',
    colAddresses: 'Adresser',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP aggregerer ikke',
    noInventory: 'Ingen enheder rapporteret indtil videre',
    interfacesTitle: 'Interfaces',
    interfacesSubtitle: 'L3-konfiguration af de registrerede NIC-enheder og de erklærede logiske enheder — set-if erstatter hele blokken, edit-if retter egenskaberne, clear-if tømmer den (eksplicit oprydning)',
    colConfig: 'Ønsket konfiguration',
    clean: 'ren',
    setIf: 'Rediger adressering',
    setIfTitle: 'Rediger adressering (set-if)',
    editIf: 'Rediger egenskaber',
    editIfTitle: 'Rediger egenskaber (edit-if)',
    clearIf: 'Tøm konfiguration',
    clearIfTitle: 'Tøm konfiguration (clear-if)',
    clearIfConfirm: 'Interfacets konfiguration tømmes. Et rent interface er forudsætningen for at underlægge det som bond-/bridge-medlem eller VLAN-parent.',
    ip4Mode: 'IPv4-tilstand',
    ip6Mode: 'IPv6-tilstand',
    modeUnconfigured: 'Ikke konfigureret',
    modeStatic: 'Statisk',
    modeDhcp: 'DHCP',
    ip4Addresses: 'IPv4-adresser',
    ip6Addresses: 'IPv6-adresser',
    addressesHint: 'CIDR, kommaseparerede',
    gw4: 'IPv4-gateway',
    gw6: 'IPv6-gateway',
    dns: 'DNS-servere',
    dnsHint: 'kommaseparerede — tomt nulstiller DNS (set-if erstatter blokken)',
    routes4: 'Statiske IPv4-ruter',
    routes6: 'Statiske IPv6-ruter',
    routeTo: 'Destination (CIDR)',
    routeVia: 'Via',
    addRoute: 'Tilføj rute',
    routesChip: 'ruter',
    mtu: 'MTU',
    mtuHint: 'tomt = driverens default',
    vlansTitle: 'VLAN',
    addVlan: 'Tilføj VLAN',
    addVlanTitle: 'Tilføj VLAN (add-vlan)',
    delVlanTitle: 'Slet VLAN (del-vlan)',
    vlanParent: 'Parent-interface',
    vlanId: 'VLAN-ID',
    vlanPreview: 'Enhedens navn',
    colParent: 'Parent',
    colVlanId: 'ID',
    noVlans: 'Ingen VLAN erklæret',
    bondsTitle: 'Bonds',
    addBond: 'Tilføj bond',
    addBondTitle: 'Tilføj bond (add-bond)',
    editBondTitle: 'Rediger bond',
    editBond: 'Gem bond',
    delBondTitle: 'Slet bond (del-bond)',
    bondName: 'Bondens navn',
    members: 'Medlemmer',
    membersHint: 'medlemmerne skal være rene interfaces (uden L3-konfiguration)',
    bondMode: 'Tilstand',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Primært medlem',
    rate: 'LACP-rate',
    hash: 'Hash-politik ved transmission',
    colMembers: 'Medlemmer',
    colMode: 'Tilstand',
    noBonds: 'Ingen bond erklæret',
    bridgesTitle: 'Bridges',
    addBridge: 'Tilføj bridge',
    addBridgeTitle: 'Tilføj bridge (add-bridge)',
    editBridgeTitle: 'Rediger bridge',
    editBridge: 'Gem bridge',
    delBridgeTitle: 'Slet bridge (del-bridge)',
    bridgeName: 'Bridgens navn',
    stp: 'STP',
    stpOn: 'STP aktiv',
    stpOff: 'STP slukket',
    colStp: 'STP',
    noBridges: 'Ingen bridge erklæret',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: 'Sæt hostname',
    setHostnameTitle: 'Sæt hostname (set-hostname)',
    hostnameHint: 'Kun OS-identitet — nodens navn i clusteret røres ikke',
    notSet: 'ikke sat',
    staticHostsTitle: 'Statiske host-poster',
    addStaticHost: 'Tilføj post',
    addStaticHostTitle: 'Tilføj statisk host-post',
    delStaticHostTitle: 'Slet statisk host-post',
    hostIp: 'IP-adresse',
    hostNames: 'Navne',
    hostNamesHint: 'komma- eller mellemrumsseparerede',
    colIp: 'IP',
    colNames: 'Navne',
    noStaticHosts: 'Ingen statiske host-poster',
    delConfirm: 'Fjernelse af {name} fra det ønskede dokument — nodens worker konvergerer med et NetworkManager-checkpoint og automatisk rollback.',
    remove: 'Fjern',
    opError: 'Netværksoperationen blev afvist'
  }
}
